import $ from "jquery";
import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./locales/en.js";
import mn from "./locales/mn.js";

Vue.use(VueI18n);

export default new VueI18n({
  locale: $("html").attr("lang"),
  messages: { en, mn },
});
